import React from 'react';
import Icon from '../../../../../components/Icon';
import { Button } from '../../../../../components';
import { WrapRemoveSingleFile } from '../styles';

const RemoveSingleFile = (props: any) => {
  const { handleRemoveSingleFile, iconName } = props;
  return (
    <WrapRemoveSingleFile>
      <Button
        data-testid="button-ds-download"
        onClick={handleRemoveSingleFile}
        className="trash"
        customized
        width="40px"
        height="40px"
        borderRadius="4px"
        alignContent="center"
        justifyContent="center"
        alignItems="center"
      >
        <Icon name={iconName} size={20} />
      </Button>
    </WrapRemoveSingleFile>
  );
};

RemoveSingleFile.defaultProps = {
  iconName: 'trash-2'
};

export default RemoveSingleFile;
